import React from 'react';
import * as Styles from './Advertisement.styles';
import { Button, Skeleton } from 'gatorcomponents';
import withErrorBoundary from '@/utils/errorBoundary';

const Advertisement = ({
  size, title, description, image, cta = { label: '', onClick: () => { } }, loading, shouldRender,
}) => {
  if (loading) {
    return (
      <Styles.Wrapper width={size} data-testid="advertisement-wrapper" loading>
        <Styles.SkeletonWrapper>
          <Skeleton width="400px" height="32px" variant="headline" />
          <Styles.SkeletonTexts>
            <Skeleton width="400px" height="150px" variant="textLine" />
            <Skeleton width="270px" height="150px" variant="textLine" />
          </Styles.SkeletonTexts>
          <Styles.SkeletonWrapper image>
            <Skeleton width="350px" height="200px" variant="rectangle" />
          </Styles.SkeletonWrapper>
          <Skeleton width="100%" height="32px" variant="button" />
        </Styles.SkeletonWrapper>
      </Styles.Wrapper>
    );
  }

  if (!shouldRender) {
    return null;
  }

  return (
    <Styles.Wrapper width={size} data-testid="advertisement-wrapper">
      <Styles.Title dangerouslySetInnerHTML={{ __html: title }} />
      <Styles.Description dangerouslySetInnerHTML={{ __html: description }} />
      {image && <Styles.AdvertisementImage src={image} alt="advertisement image" />}
      {cta.label && (
        <Button
          label={cta.label}
          variant="secondary"
          onClick={cta.onClick}
          version="v2"
          size="large"
        />
      )}
    </Styles.Wrapper>
  );
};
export default withErrorBoundary(Advertisement, 'Advertisement');
